import { render, staticRenderFns } from "./feishuGroup.vue?vue&type=template&id=deb55bc2&scoped=true&"
import script from "./feishuGroup.vue?vue&type=script&lang=js&"
export * from "./feishuGroup.vue?vue&type=script&lang=js&"
import style0 from "./feishuGroup.vue?vue&type=style&index=0&id=deb55bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb55bc2",
  null
  
)

export default component.exports